var _path, _path2, _path3, _path4, _use, _use2, _use3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-gg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h512v512H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8112d",
    d: "M192 0h128v512H192z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8112d",
    d: "M0 187.7h512v136.6H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "a",
    fill: "#f9dd16",
    d: "m46 305.8 23.3-25h210v-49.7h-210L46 206.2z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: 36,
    height: 24,
    transform: "matrix(0 1.06667 -.9375 0 496 -17)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: 36,
    height: 24,
    transform: "matrix(0 -1.06667 .9375 0 16 529)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: 36,
    height: 24,
    transform: "rotate(180 256 256)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGg);
export default __webpack_public_path__ + "static/media/gg.e9d7238c94cc4589ac0ee16c9d7009c9.svg";
export { ForwardRef as ReactComponent };